import { useTranslation } from "react-i18next";
import Usuario from "../../components/classes/Usuario";
import Utils from "../../helper/utils";
import style from "./pageStyle.module.css";

export const Page = () => {
  Utils.setDocumentTitle("Home");
  const usuario: Usuario = JSON.parse(String(localStorage.getItem("UsuarioCache")));

  const { t } = useTranslation();
  const userName = usuario?.nome

  return (
    <>
      <div className={style.div__principal}>
        <div className={style.div__card}>
          <div className={style.div__logo}>
            <img src="logo-brf.png" />
          </div>
          <p>{t("home.welcome", { userName })}</p>
        </div>
      </div>
    </>
  );
};

export default Page;
